"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ProductNameCell = void 0;
const react_1 = __importDefault(require("react"));
const ui_components_1 = require("@groupby/ui-components");
const material_1 = require("@mui/material");
const styled_components_1 = require("styled-components");
const product_name_cell_styles_1 = require("./product-name-cell.styles");
const icons_1 = require("../../../../../../../icons");
/**
 * Cell component for displaying product names with details access.
 *
 * This component provides:
 * - Product name display with text overflow handling
 * - Tooltip support for long product names
 * - Details icon button to open product details
 * - Compatible with both legacy and new DataGrid formats
 *
 * **Usage:** Can be used in both old and new table systems as it doesn't depend
 * on specific table implementation details.
 *
 * @example
 * ```tsx
 * <ProductNameCell
 *   productName="Sample Product Name"
 *   productId="prod-123"
 *   onActiveProductIdChange={handleProductDetailsOpen}
 * />
 * ```
 */
const ProductNameCell = ({ productName, productId, onActiveProductIdChange }) => {
    const theme = (0, styled_components_1.useTheme)();
    const { isTooltipOpen, onTooltipShow, onTooltipClose, } = (0, ui_components_1.useDataGridCellTooltip)({ contentSelector: null });
    return (react_1.default.createElement(material_1.Tooltip, { arrow: true, open: isTooltipOpen, title: productName, onClose: onTooltipClose }, react_1.default.createElement(product_name_cell_styles_1.StyledProductNameCellContent, null, react_1.default.createElement(ui_components_1.Typography, { variant: "body2", onMouseEnter: onTooltipShow }, productName), !!onActiveProductIdChange && (react_1.default.createElement(product_name_cell_styles_1.StyledProductDetailsIconButton, { onClick: () => onActiveProductIdChange(productId) }, react_1.default.createElement(icons_1.DetailsIcon, { stroke: theme.palette.primary.main }))))));
};
exports.ProductNameCell = ProductNameCell;
